import { call, put } from "redux-saga/effects";
import { signupRequest } from "../../requests/basic/signupRequest";
import {
  setSignupServerErrorsAction,
  setSignupServerSuccessAction,
} from "../../../slices/basic/signupSlice";


export function* signupHandler(action) {
  try {
    yield call(signupRequest, { ...action.payload });
    yield put(setSignupServerSuccessAction());
    // User must verify email via link before logging in; no token or auto-login
  } catch (error) {
    if (error.response?.status !== 500)
      yield put(setSignupServerErrorsAction({ errors: error.response?.data }));
    console.log({ ...error });
  }
}
